import React from 'react';
import { Spacer } from '@ontruck/orc';

const urlRenderer = (param) => (props) => {
  if (!param) {
    return null;
  }

  const url = props?.changes?.[param];

  if (!url) {
    return null;
  }

  return (
    <Spacer {...props}>
      <a href={url} target="_blank" rel="noreferrer" data-testid="link">
        {url}
      </a>
    </Spacer>
  );
};

export default urlRenderer;
